import { HTTPError } from 'ky';

export default class OneUnauthorizedError extends Error {
  constructor(cause?: HTTPError) {
    super('Unauthorized access error', { cause });

    Object.setPrototypeOf(this, OneUnauthorizedError.prototype);
  }

  getCause() {
    return this.cause as HTTPError;
  }
}
